import * as Yup from "yup";


export const HairTestSchema = Yup.object({
 
    hair_location: Yup.string().required("Filed is Required"),
    fungal_typ: Yup.string().required("Filed is Required"),
    structure_typ: Yup.string().required("Filed is Required"),
    metal_typ: Yup.string().required("Filed is Required"),
    hair_color: Yup.string().required("Filed is Required"),
    metal_concetration: Yup.string().required("Filed is Required"),
    keratin_presence: Yup.string().required("Filed is Required"),
    protein_level: Yup.string().required("Filed is Required"),
    asp: Yup.string().required("Filed is Required"),
    hmp: Yup.string().required("Filed is Required"),


});